import API_BASE_URL from './apiConfig';

export async function getUserPreferences(token) {
  const res = await fetch(`${API_BASE_URL}/auth/preferences`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error('Failed to fetch preferences');
  return res.json();
}

export async function deleteUserAccount(token) {
  const res = await fetch(`${API_BASE_URL}/auth/account`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error('Failed to delete account');
  return res.json();
}

export async function updateUserPreferences(token, preferences) {
  const res = await fetch(`${API_BASE_URL}/auth/preferences`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(preferences),
  });
  if (!res.ok) throw new Error('Failed to update preferences');
  return res.json();
}
